import styled, { css } from 'styled-components'
import { merchantThemes, fonts, device } from 'components/Variable'
import { rem } from 'utils/common'

const RefundStoreCreditBlockCommons = css`
	font-family: ${fonts.openSans};
	font-weight: 600;
	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
		${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
		${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
		${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
		${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
		${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			font-weight: normal;
		`}
		${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}
`

export const RefundBlock = styled.div`
	background: ${({ theme }) => theme.color.secondary};
	border-radius: ${rem(8)};
	min-width: ${rem(600)};
	width: ${rem(600)};
	margin: ${rem(15)} auto;
	padding: 0 0 ${rem(30)} 0;

	@media (${device.tablet}) {
		background: transparent;
		min-width: 100%;
		width: 100%;
		margin: 0 auto ${rem(15)} auto;
	}
`

export const RefundTitle = styled.div`
	border-radius: ${rem(8, 8, 0, 0)};
	font-size: ${rem(20)};
	font-weight: 600;
	font-family: ${fonts.signika};
	text-transform: uppercase;
	background: ${({ theme }) => theme.color.grayFifteen};
	padding: ${rem(17, 0, 18, 0)};
	text-align: center;
	position: relative;

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			font-size: ${rem(15)};
			font-weight: normal;
			text-transform: none;
			background: transparent;
		`}
		
	${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}

	${(props) =>
		props.green &&
		css`
			text-transform: uppercase;
			background: ${({ theme }) => theme.color.primary};
			color: ${({ theme }) => theme.color.secondary};

			${(p) =>
				p.theme.name === merchantThemes.toteme &&
				css`
					text-transform: none;
				`}
		`}

	${(p) =>
		p.icon &&
		css`
			padding: ${rem(13, 19)};
			border-color: rgba(0, 0, 0, 0.5);
			svg {
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
			}
		`}
	
	@media (${device.mobileM}) {
		background: transparent;
		border-radius: 0;

		${(props) =>
			props.green &&
			css`
				background: ${({ theme }) => theme.color.primary};
				font-size: ${rem(16)};
				padding: ${rem(13, 13)};
				margin: 0 ${rem(-15)} ${rem(20)} ${rem(-15)};

				> svg {
					display: none;
				}

				${(p) =>
					p.theme.name === merchantThemes.toteme &&
					css`
						font-size: ${rem(15)};
					`}
			`}
	}
`

export const RefundTitleText = styled.div`
	display: inline-block;
	position: relative;
	padding: 0 0 0 ${rem(35)};
`

export const RefundIcon = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	left: 0;
`

export const RefundStoreCreditBlock = styled.div`
	background: ${({ theme }) => theme.color.greenThree};
	border: ${rem(1)} solid ${({ theme }) => theme.color.primary};
	box-sizing: border-box;
	border-radius: ${rem(2)};
	max-width: ${rem(418)};
	margin: ${rem(30)} auto ${rem(20)} auto;
	text-align: center;
	padding: ${rem(33, 0, 33, 0)};

	${(p) =>
		p.theme.name === merchantThemes.musto &&
		css`
			background: ${({ theme }) => theme.color.tertiatyOne};
		`}

	${(props) =>
		props.grey &&
		css`
			background: ${({ theme }) => theme.color.graySixteen};
			border: ${rem(1)} solid ${({ theme }) => theme.color.blackOne};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			background: ${({ theme }) => theme.color.secondary};
		`}
`

export const RefundStoreCreditBlockTitle = styled.div`
	${RefundStoreCreditBlockCommons};
	font-size: ${rem(18)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
		`}
`

export const RefundStoreCreditBlockSum = styled.div`
	${RefundStoreCreditBlockCommons};
	font-size: ${rem(24)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
		`}
`

export const RefundStoreCreditBlockDescription = styled.div`
	${RefundStoreCreditBlockCommons};
	font-size: ${rem(14)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
		`}
`

export const RefundStoreCreditBlockPreviewBlock = styled.div`
	font-family: ${fonts.openSans};
	font-weight: 400;
	margin: ${rem(30, 0)};
	text-align: center;
	font-size: ${rem(14)};
	color: ${({ theme }) => theme.color.grayTen};

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
		
	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			font-weight: normal;
			font-size: ${rem(15)};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}
`

export const RefundStoreCreditBlockShippingOptionInfo = styled.div`
	font-family: ${fonts.openSans};
	font-weight: 400;
	margin: ${rem(30, 0)};
	text-align: center;
	font-size: ${rem(14)};
	color: ${({ theme }) => theme.color.grayTen};

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
		
	${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			font-size: ${rem(15)};
		`}
	
	${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}
`
export const RefundSeparator = styled.div`
	height: ${rem(1)};
	background: ${({ theme }) => theme.color.grayTwelve};
	margin-top: ${rem(40)};

	@media (${device.mobileM}) {
		display: none;
	}
`

export const RefundSubTitle = styled.div`
	font-family: ${fonts.signika};
	text-align: center;
	margin: ${rem(30)} 0;
	font-weight: 600;

	${(p) =>
		p.theme.name === merchantThemes.woodwood &&
		css`
			font-family: ${fonts.WWBeta8Regular};
		`}

	${(p) =>
		p.theme.name === merchantThemes.hh &&
		css`
			font-family: ${fonts.dinPro};
		`}
	 
    ${(p) =>
		p.theme.name === merchantThemes.marysia &&
		css`
			font-family: ${fonts.futura};
		`}
	${(p) =>
		p.theme.name === merchantThemes['8848'] &&
		css`
			font-family: ${fonts.futura};
		`}
		${(p) =>
		p.theme.name === merchantThemes.aycane &&
		css`
			font-family: ${fonts.IBMPlex};
		`}
		${(p) =>
		p.theme.name === merchantThemes.bymalina &&
		css`
			font-family: ${fonts.Avenir};
		`}
		${(p) =>
		p.theme.name === merchantThemes.henrylloyd &&
		css`
			font-family: ${fonts.Gotham};
		`}
		${(p) =>
		p.theme.name === merchantThemes.chimi &&
		css`
			font-family: ${fonts.AmericaExpandedRegular};
		`}
		${(p) =>
		p.theme.name === merchantThemes.ogoship &&
		css`
			font-family: ${fonts.usual};
		`}
		${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-family: ${fonts.MonumentGrotesk};
			font-weight: normal;
			text-transform: none;
		`}
		${(p) =>
		p.theme.name === merchantThemes.sns &&
		css`
			font-family: ${fonts.AktivGroteskEx};
		`}
`
export const RefundSeparatorWrapper = styled.div`
	display: none;

	@media (${device.mobileM}) {
		display: flex;
		justify-content: center;
	}
`
